import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import StepApprovers from 'modules/approvals/store/collections/stepApprovers'

export const useStepApproversCount = (approvalFlowId: number | undefined) => {
  const stepApproversCollection = useLazyRef(() => new StepApprovers()).current

  const { loading } = useAsyncData(async () => {
    if (!approvalFlowId) return { loading: true }

    return await stepApproversCollection.fetch({
      data: {
        approval_flow_ids: [approvalFlowId],
      },
    })
  }, [approvalFlowId])

  if (loading)
    return {
      loading,
      stepApproversCount: null,
    }

  return { loading: false, stepApproversCount: stepApproversCollection.models.length }
}
